module.exports = __webpack_public_path__ + "img/132.ae47e653.jpg";